import {
	primaryColor,
	primaryBoxShadow,
	whiteColor,
	blackColor,
	grayColor,
	hexToRgb,
	blackColors,
} from 'assets/jss/material-dashboard-pro-react';
import { darken } from '@material-ui/core/styles';
import Done from 'assets/img/done.svg';
import { defaultBodyFont } from './components/typographyStyle';

const customSelectStyle = (theme) => ({
	icon: {
		width: '16px',
		height: '16px',
		top: 'calc(50% - 8px)',
	},
	select: {
		padding: '8px 0 7px',
		fontSize: '.75rem',
		textDecoration: 'none',
		color: grayColor[2],
		'&:focus': {
			backgroundColor: 'transparent',
		},
		'&[aria-owns] + input + svg': {
			transform: 'rotate(180deg)',
		},
		'& + input + svg': {
			transition: 'all 300ms linear',
		},
		...defaultBodyFont(theme),
	},
	selectFormControlUnderline: {
		'& > div': {
			'&:before': {
				borderBottomWidth: '1px !important',
				borderBottomColor: blackColors[3] + '!important',
			},
			'&:after': {
				borderBottomColor: primaryColor[0] + '!important',
			},
		},
	},
	selectFormControl: {
		margin: '7px 0 17px 0 !important',
		...defaultBodyFont(theme),
	},
	selectFormControlNotEmptyUnderline: {
		'& > div': {
			'&:before': {
				borderBottomWidth: '2px !important',
				borderBottomColor: blackColors[2] + '!important',
			},
		},
	},
	selectFormDisabledUnderline: {
		'& > div': {
			'&:before': {
				borderBottomColor: blackColors[4] + '!important',
				borderBottomStyle: 'solid !important',
			},
		},
	},
	selectFormDisabled: {
		'& svg': {
			color: blackColors[4],
		},
	},
	selectMenuLabel: {
		fontSize: theme.fontSize(14),
		color: blackColors[1],
		'&.Mui-disabled': {
			color: blackColors[4] + ' !important',
		},
	},
	shrink: {
		fontSize: `${theme.fontSize(12)}!important`,
		transform: 'none',
	},
	selectLabel: {
		fontSize: theme.fontSize(14),
		color: blackColors[2] + ' !important',
		...defaultBodyFont(theme),
	},
	selectLabelHover: {
		color: blackColors[1] + ' !important',
	},
	selectLabelDisabled: {
		color: blackColors[3] + ' !important',
	},
	selectMenu: {
		'& > div > ul': {
			border: '0',
			padding: '5px 0',
			margin: '0',
			boxShadow: 'none',
			minWidth: '100%',
			borderRadius: '4px',
			boxSizing: 'border-box',
			display: 'block',
			fontSize: theme.fontSize(14),
			textAlign: 'left',
			listStyle: 'none',
			backgroundColor: whiteColor,
			backgroundClip: 'padding-box',
		},
		'& $selectPaper $selectMenuItemSelectedMultiple': {
			backgroundColor: 'inherit',
		},
		'& > div + div': {
			maxHeight: '266px !important',
		},
		'& .MuiPaper-root': {
			borderRadius: 4,
			'& .MuiList-root': {
				padding: '8px 0',
				'& .MuiButtonBase-root': {
					margin: 0,
					borderRadius: 0,
					boxShadow: 'none',
					padding: '13px 38px 11px 8px',
					transition: 'background-color .3s ease-in-out',
					'&:hover': {
						backgroundColor: `rgba(${hexToRgb(primaryColor[0])},0.2)!important`,
						color: 'inherit',
					},
					'&:active': {
						backgroundColor: `${darken(primaryColor[0], 0.12)}!important`,
						color: whiteColor,
					},
					'&.Mui-selected': {
						backgroundColor: `${darken(primaryColor[0], 0.24)}!important`,
						color: whiteColor,
						backgroundImage: `url(${Done})`,
						backgroundRepeat: 'no-repeat',
						backgroundSize: '14px',
						backgroundPosition: '85%',
					},
				},
			},
		},
	},
	selectMenuItem: {
		fontSize: theme.fontSize(14),
		padding: '12px 16px 12px 8px',
		margin: '0 20px 0 8px',
		borderRadius: '4px',
		transition: 'all 150ms linear',
		clear: 'both',
		minHeight: '40px',
		whiteSpace: 'nowrap',
		paddingRight: '30px',
		display: 'flex',
		'&:hover': {
			backgroundColor: primaryColor[0],
			color: whiteColor,
			...primaryBoxShadow,
		},
		...defaultBodyFont(theme),
		letterSpacing: '0.2px !important',
		color: blackColors[1],
		'&:focus,&:active': {
			backgroundColor: darken(primaryColor[0], 0.12),
			color: whiteColor + ' !important',
		},
		'&.Mui-disabled': {
			opacity: 1,
			color: blackColors[3],
		},
	},
	selectMenuItemSelected: {
		backgroundColor: primaryColor[0] + '!important',
		color: whiteColor,
	},
	selectMenuItemSelectedMultiple: {
		backgroundColor: 'transparent !important',
		'&:hover': {
			backgroundColor: primaryColor[0] + '!important',
			color: whiteColor,
			...primaryBoxShadow,
			'&:after': {
				color: whiteColor,
			},
		},
		'&:after': {
			top: '16px',
			right: '12px',
			width: '12px',
			height: '5px',
			borderLeft: '2px solid currentColor',
			transform: 'rotate(-45deg)',
			opacity: '1',
			color: blackColors[1],
			position: 'absolute',
			content: "''",
			borderBottom: '2px solid currentColor',
			transition: 'opacity 90ms cubic-bezier(0,0,.2,.1)',
		},
	},
	selectPaper: {
		boxSizing: 'borderBox',
		borderRadius: '4px',
		padding: '0',
		minWidth: '100%',
		display: 'block',
		border: '0',
		boxShadow: '0 2px 5px 0 rgba(' + hexToRgb(blackColor) + ', 0.26)',
		backgroundClip: 'padding-box',
		margin: '2px 0 0',
		fontSize: theme.fontSize(14),
		textAlign: 'left',
		listStyle: 'none',
		backgroundColor: 'transparent',
		maxHeight: '266px',
	},
});

export default customSelectStyle;
